var Component = require("!../../vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../vue-loader/lib/selector?type=script&index=0!./col.vue"),
  /* template */
  require("!!../../vue-loader/lib/template-compiler?{\"id\":\"data-v-4adf6522\"}!../../vue-loader/lib/selector?type=template&index=0!./col.vue"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./~/ci-components/components/col.vue
// module id = 240
// module chunks = 4